import { State } from './models';

export const sections = (state): State.IState => state.get('sections');
